class InventoryAndPricingSyncService {
    static syncInventoryAndPricingInterval = null;
    constructor(product, products_container, cart_button) {
        this.product = product;
        this.products_container = products_container;
        this.cart_button = cart_button;

        this.isRealTimePriceUpdating = false;
        this.boundQtyInputs = new WeakSet();

        const { loadingText, infoIcon } = window?.fetchPricesConfig || {};
        this.loadingText = loadingText;
        this.infoIcon = infoIcon;
    }

    async startInventoryAndPricingSyncForCart(hasRun = false) {
        const priceUpdater = await this.waitForPriceUpdaterReady();

        let currency = priceUpdater.getCookieValue("cart_currency") || "";
        this.currency = (currency === 'USD') ? "$" : currency;

        this.waitForInventoryDom().then(() => {
            this.syncInventoryAndPricing();


            if (!hasRun) {
                this.addToCart();
            }
            
            if(!InventoryAndPricingSyncService.syncInventoryAndPricingInterval){
                InventoryAndPricingSyncService.syncInventoryAndPricingInterval = setInterval(() => this.syncInventoryAndPricing(), 120000);
            }
            const cartInput = document.querySelectorAll('.qty-input__input.input');
            if(cartInput) {
                for(let input of cartInput) {
                    if (this.boundQtyInputs.has(input)) continue;
                    this.boundQtyInputs.add(input);
                    input.addEventListener('input', () => {
                        this.syncInventoryAndPricing();
                    });
                }
            }
        });
    }


    async startInventoryAndPricingSyncForPDP(hasRun = false) {
        const priceUpdater = await this.waitForPriceUpdaterReady();

        let currency = priceUpdater.getCookieValue("cart_currency") || "";
        this.currency = (currency === 'USD') ? "$" : currency;

        this.waitForInventoryDom().then(() => {
            this.syncInventoryAndPricing();

          if (!hasRun) {
                this.addToCart();
            }
            
            if(!InventoryAndPricingSyncService.syncInventoryAndPricingInterval){
                InventoryAndPricingSyncService.syncInventoryAndPricingInterval = setInterval(() => this.syncInventoryAndPricing(), 120000);
            }
            const cartInput = document.querySelectorAll('.qty-input__input.input');
            if(cartInput) {
                for(let input of cartInput) {
                    if (this.boundQtyInputs.has(input)) continue;
                    this.boundQtyInputs.add(input);
                    input.addEventListener('input', () => {
                        this.syncInventoryAndPricing();
                    });
                }
            }
        });
    }

    waitForPriceUpdaterReady() {
        return new Promise(resolve => {
            const check = () => {
                if (
                    window?.priceUpdater &&
                    typeof window.priceUpdater.getCookieValue === 'function'
                ) {
                    resolve(window.priceUpdater);
                    return;
                }
                requestAnimationFrame(check);
            };
            check();
        });
    }

    waitForInventoryDom() {
        return new Promise(resolve => {
            const checkElements = () => {
                const qtyElements = document.querySelectorAll(`.${this.product} .warehouse-qty`);
                const warehouseGrids = document.querySelectorAll(`.${this.product} .warehouse-grid`);
                const warehouseItems = document.querySelectorAll(`.${this.product} .warehouse-item`);

                if (qtyElements.length && warehouseGrids.length && warehouseItems.length) {
                    resolve({ qtyElements, warehouseGrids, warehouseItems });
                    return;
                }

                requestAnimationFrame(checkElements);
            };

            checkElements();
        });
    }

    async syncInventoryAndPricing() {
        if (this.isRealTimePriceUpdating) return;

        const qtyElements = document.querySelectorAll(`.${this.product} .warehouse-qty`);
        const warehouseGrids = document.querySelectorAll(`.${this.product} .warehouse-grid`);
        const warehouseItems = document.querySelectorAll(`.${this.product} .warehouse-item`);
        const yourPriceItems = document.querySelectorAll(`.${this.product} .your-price .value`);

        const hitsContainer = document.querySelector(`.${this.products_container}`);

        if (hitsContainer && window?.priceUpdater?.getAlgoliaInventoryAndPricing) {
            this.isRealTimePriceUpdating = true;

            qtyElements.forEach(el => {
                el.style.position = 'relative';
                el.innerHTML = `
                <div class="loading-spinner" role="status">
                    <span class="sr-only">${this.loadingText || 'Loading'}</span>
                </div>
                `;
            });

            yourPriceItems.forEach(el => {
                el.style.position = 'relative';
                el.innerHTML = `
                <div class="loading-spinner" role="status">
                    <span class="sr-only">${this.loadingText || 'Loading'}</span>
                </div>
                `;
            });

            window.priceUpdater
            .getAlgoliaInventoryAndPricing(hitsContainer)
            .then(result => {
                this.updateInventoryAndPrices(result);
            })
            .catch(error => {
                const checkoutBtn = document.querySelector('button[name="checkout"]');
                if(checkoutBtn) {
                    checkoutBtn.disabled = true;
                }
                
                console.error('Internal Server Error:', error);

                warehouseItems.forEach(item => {
                    item.style.display = 'none';
                });

                warehouseGrids.forEach(grid => {
                    const existingBackorder = grid.querySelector('.warehouse-backorder');
                    if (existingBackorder) existingBackorder.remove();

                    let existing = grid.querySelector('.error-fetching-inventory');
                    if (!existing) {
                        const errDiv = document.createElement('div');
                        errDiv.className = 'error-fetching-inventory';
                        errDiv.innerText = 'Failed to load inventory data';
                        grid.appendChild(errDiv);
                    }
                });

                yourPriceItems.forEach(el => {
                    const spinner = el.querySelector('.loading-spinner');
                    if (spinner) el.removeChild(spinner);
                    el.innerText = 'N/A';
                });
            })
            .finally(() => {
                this.isRealTimePriceUpdating = false;

                qtyElements.forEach(qtyEl => {
                    const spinner = qtyEl.querySelector('.loading-spinner');
                    if (spinner) qtyEl.removeChild(spinner);
                });

                yourPriceItems.forEach(el => {
                    const spinner = el.querySelector('.loading-spinner');
                    if (spinner) el.removeChild(spinner);
                });
            });
        }
        else {
            this.isRealTimePriceUpdating = false;
        }
    }

    formatUSPrice(value) {
        if (value === null || value === undefined || value === "") return null;
        const num = Number(value);
        if (isNaN(num)) return null;

        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    }

    addToCart() {
        setTimeout(() => {
            document.querySelectorAll(`.${this.cart_button}`).forEach(btn => {
                btn.dataset.customAtc = 'true';

                btn.addEventListener('click', e => {
                    e.preventDefault();
                    e.stopPropagation();

                    const form = btn.closest('form');
                    if (!form) return;

                    const variantId = form.querySelector('input[name="id"]').value;
                    const qtyInput = form.querySelector('input[name="quantity"]');
                    const quantity = qtyInput ? parseInt(qtyInput.value) || 0 : 0;

                    if (!Number.isInteger(quantity) || quantity <= 0) return;

                    btn.disabled = true;
                    const originalText = btn.textContent;
                    btn.textContent = 'Adding...';

                    const formData = {
                        items: [{ id: variantId, quantity }]
                    };

                    fetch(`${theme.routes.cartAdd}.js`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(formData)
                    })
                    .then(r => r.json())
                    .then(async (data) => {
                        const addedItem = data?.items?.[0]
                        await window?.priceUpdater?.addedToCart({
                            variantId: addedItem?.variant_id,
                            quantity: addedItem?.quantity,
                            sku: addedItem?.sku
                        })
                        btn.textContent = originalText;
                        btn.disabled = false;

                        fetch(`${window.location.pathname}?sections=cart-icon-bubble`)
                            .then(r => r.json())
                            .then(sections => {
                                const bubble = document.getElementById('cart-icon-bubble');
                                if (bubble && sections['cart-icon-bubble']) {
                                    bubble.innerHTML = sections['cart-icon-bubble'];
                                }
                            });

                        const cartItems = document.querySelector('cart-items');
                        if (cartItems) {
                            if (cartItems.dataset.empty === 'true') {
                                window.location.reload();
                            } else {
                                cartItems.refreshAndUpdateInventory();
                            }
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            });
                        }
                        if (window.Toast) {
                            window.Toast.success('Product added to cart', 2000);
                        }
                    })
                    .catch(console.error);
                });
            });
        }, 0);
    }

    updateInventoryAndPrices(priceAndInventoryMap) {
        let hasCartSubtotal = false;
        try {
        document
        .querySelectorAll(`.${this.products_container} .${this.product}`)
        .forEach(container => {
            const variantId = container.dataset.variantId;
            const data = priceAndInventoryMap[variantId];

            container.querySelectorAll('.warehouse-qty').forEach(qtyEl => {
                const child = qtyEl.querySelector('.loader');
                if (child) qtyEl.removeChild(child);
            });

            container.querySelectorAll('.your-price .value').forEach(el => {
                const spinner = el.querySelector('.loading-spinner');
                if (spinner) el.removeChild(spinner);
            });

            if (!data) {
                container.querySelectorAll('.warehouse-qty').forEach(el => (el.textContent = '-'));
                container.querySelectorAll('.your-price .value').forEach(el => (el.innerHTML = 'N/A'));
                return;
            }

            const stockByLocation = {};
            data.inventory.forEach(loc => {
                stockByLocation[loc.LocationID] = parseFloat(loc.FreeQuantity) || 0;
            });

            container.querySelectorAll('.warehouse-grid').forEach(grid => {
                const existingError = grid.querySelector('.error-fetching-inventory');
                if (existingError) existingError.remove();

                if (data.total_qty && data.total_qty > 0) {
                    const backorder = grid.querySelector('.warehouse-backorder');
                    if (backorder) backorder.remove();

                    grid.querySelectorAll('.warehouse-item').forEach(item => {
                        item.style.display = 'flex';
                        const locId = item.dataset.warehouseLocationId;
                        const qtyEl = item.querySelector('.warehouse-qty');
                        if (!locId || !qtyEl) return;
                        qtyEl.innerHTML = stockByLocation[locId] || '0';
                    });
                } else {
                    grid.querySelectorAll('.warehouse-item').forEach(i => (i.style.display = 'none'));

                    if (!grid.querySelector('.warehouse-backorder')) {
                        const errDiv = document.createElement('div');
                        errDiv.className = 'warehouse-backorder';
                        errDiv.innerHTML = `
                        <div class="inventory-backorder-info">
                            <span class="inventory-backorder-message"> Available for Backorder </span>
                            <span class="info-icon-wrapper">
                            <img src="${this.infoIcon}" alt="Info" class="info-icon" width="12" height="12" style="box-sizing: content-box;" />
                            <div class="info-tooltip">
                                <a href="tel:+18668372550" class="contact-btn">Contact</a>
                                <span> us for estimated delivery date.</span>
                            </div>
                            </span>
                        </div>
                        <div class="inventory-contact">
                            <a href="tel:+18668372550" class="contact-btn">Contact</a>
                            <span> us for estimated delivery date.</span>
                        </div>`;
                        grid.appendChild(errDiv);
                        
                        const wrapper = errDiv.querySelector('.info-icon-wrapper');
                        wrapper.addEventListener('click', (event) => {
                            if (event.target.closest('.contact-btn')) {
                                return;
                            }
                            event.preventDefault();
                            event.stopPropagation();
                            wrapper.classList.toggle('tooltip-open');
                        });

                        document.addEventListener('click', (event) => {
                            event.stopPropagation();
                            if (wrapper.contains(event.target)) return;
                            wrapper.classList.remove('tooltip-open');
                        });

                        document.addEventListener('keydown', (event) => {
                            event.stopPropagation();
                            if (event.key === 'Escape') {
                                wrapper.classList.remove('tooltip-open');
                            }
                        });
                    }
                }
            });

            const listPriceEl = container.querySelector('.list-price .value')
            if (listPriceEl) {
                listPriceEl.textContent =
                data.list_price
                    ? `${this.currency}${this.formatUSPrice(data.list_price)} / EA`
                    : ' N/A';
            }

            const cartSubtotal = container.querySelector(".cart-subtotal .value");
            const netPriceEl = container.querySelector('.your-price .value');
            if (netPriceEl && cartSubtotal) {
                netPriceEl.innerHTML = `${this.currency}${this.formatUSPrice(data.net_price)}`;
            }
            else if(netPriceEl) {
                netPriceEl.innerHTML = `${this.currency}${this.formatUSPrice(data.net_price)} <span class="js-value"> / EA</span>`;
            }

            if(cartSubtotal) {
                const cartQty = container.querySelector('.qty-input__input.input')?.value;
                const subtotal = cartQty * Number(this.formatUSPrice(data.net_price).replace(/,/g, ""));
                cartSubtotal.innerText = `${this.currency}${this.formatUSPrice(subtotal)}`;
                hasCartSubtotal = true;
            }
        });
        } finally {
        if (hasCartSubtotal) {
            const checkoutSubtotal = document.querySelector('.cart-summary__subtotal-price');
            let totalPrice = 0;
            for (let item of document.querySelectorAll('.cart-subtotal .value')) {
                const text = item.textContent || item.innerText;
                const price = text.replace(/[^0-9.]/g, '');
                totalPrice += parseFloat(price) || 0;
            }
            checkoutSubtotal.innerHTML = `${this.currency}${this.formatUSPrice(totalPrice)} <span class="js-value">${priceUpdater.getCookieValue("cart_currency")}</span>`;
        }
        }
    }
}